import { TextBoxSearchOutlineIcon } from './TextBoxSearchOutlineIcon';

/**
 * author: Austin Andrews
 * id D32F390E-2888-4C63-99FA-9662902B6694
 * name text-box-search-outline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box-search-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentBoxSearchOutlineIcon = TextBoxSearchOutlineIcon;
export default FileDocumentBoxSearchOutlineIcon